import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getDocsTopics = async () => {
  return await request.get(
    '/Docs/topics',
    null,
    'При получении списка тем произошла ошибка'
  );
};

const useDocsTopicsQuery = (options) =>
  useQuery(queryKeys.topicsDocs(), getDocsTopics, options);

export default useDocsTopicsQuery;
